module.exports = __webpack_public_path__ + "img/icon_tk_foot_anz.26ae7801.png";